import React, { useRef, useState } from 'react';
import {
  publish,
} from '@wh/message-bus';
import cx from 'classnames';

import Carousel from './carousel/Carousel';
import { useMessageBusSubscribe } from '../messagebus';


export const ProductMenu = ({
  items,
  redirectToProduct = true
}) => {

  const [activeItem, setActiveItem] = useState(-1);
  const [loadingItem, setLoadingItem] = useState(-1);
  const loadingItemTimeout = useRef();

  useMessageBusSubscribe('wh.common.command.ui.header.product.select', (data) => {
    const item = items.findIndex(({ id }) => { return data.id === id });
    if (item !== -1) {
      setActiveItem(item);
    }
  }, [items]);

  const select = ({ label, url, id, index, redirectToProduct }) => {
    publish('wh.common.event.ui.header.product.requested', {
      label,
      id,
      link: {
        url,
      },
      redirectToProduct
    });
    if (redirectToProduct) {
      window.location.assign(url);
    }
    setLoadingItem(index);
    if (loadingItemTimeout.current) {
      clearTimeout(loadingItemTimeout.current);
    }
    loadingItemTimeout.current = setTimeout(() => {
      setLoadingItem(-1);
    }, 4000);
  }

  return <Carousel outfit="stretched transparent" activeElement={activeItem} loadingElement={loadingItem}>
    {items.map(({ label, url, id }, index) => (
      <a
        href={url}
        key={index}
        className={cx('sb-header-nav-item', { 'sb-header-nav-item--active': (index === activeItem), 'sb-header-nav-item--loading': (index === loadingItem) })}
        data-test-id={`@sitebase/product-menu.item__product-menu-item-${label}`}
        onClick={(e) => { e.preventDefault(); select({ label, url, id, index, redirectToProduct }); } }
        >{label}</a>
    ))}
  </Carousel>;
}
